<template>
  <div class="projectPage">
    <data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :options="addObj"
      @ok="addProject"
    />

    <vs-table ref="table" :max-items="itemsPerPage" :data="dataTransformed">
      <div slot="header" class="w-full">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewDataSidebar = true"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New Project</span>
          </div>

          <!-- Search -->
          <!-- <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="searchPrompt = true"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base">Search</span>
          </div> -->

          <!-- <vs-prompt
            title="Search"
            @cancel="val = ''"
            @accept="searchQuery"
            @close="searchPrompt = false"
            :active.sync="searchPrompt"
          >
            <div class="con-exemple-prompt">
              <span>Enter a Phone# or Email to search</span>
              <vs-input
                @keyup.enter="searchQuery"
                placeholder="eg. john@company.com,Company Name...."
                vs-placeholder="eg. john@company.com,416499...."
                v-model="query"
                class="mt-3 w-full"
              />
            </div>
          </vs-prompt> -->
        </div>

        <!-- <div
          class="flex justify-between py-3 px-4 rounded"
          style="background:#eee"
          v-if="searchedTerm"
        >
          <span>
            Showing {{ searchResults.length }} results for
            <b>"{{ searchedTerm }}"</b>
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch"
            >Clear Search</vs-button
          >
        </div> -->

        <!-- ITEMS PER PAGE -->
      </div>

      <template slot="thead">
        <vs-th sort-key="uid">Project No.</vs-th>
        <vs-th sort-key="name">Project Name</vs-th>
        <vs-th>Description</vs-th>
        <vs-th sort-key=""></vs-th>
        <vs-th sort-key=""></vs-th>
        <!-- <vs-th sort-key="order_status">Confirmed</vs-th> -->
        <!-- <vs-th sort-key="price">Price</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td>
              <router-link
                :to="`/account/${tr.id}`"
                class="product-name font-medium"
                >{{ tr.username }}</router-link
              >
            </vs-td> -->

            <vs-td>
              <p class="projectId">{{ tr.uid }}</p>
            </vs-td>
            <vs-td>
              <p class="projectName">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              {{ tr.description }}
              <!-- <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))" class="shadow-md" /> -->
            </vs-td>
            <vs-td>
              <vs-button
                @click.native="getClientProject(tr)"
                radius
                color="green"
                type="filled"
                icon-pack="feather"
                size="small"
                icon="icon-edit"
              ></vs-button>
            </vs-td>

            <vs-td>
              <vs-button
                @click.native="deleteProject(tr)"
                radius
                color="danger"
                type="filled"
                icon-pack="feather"
                size="small"
                icon="icon-trash"
              ></vs-button>
            </vs-td>
            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full">
                <vs-th>Ticket No.</vs-th>
                <vs-th>Date</vs-th>
                <vs-th>Time</vs-th>
                <vs-th sort-key="">Product</vs-th>
                <vs-th sort-key="">Truck</vs-th>
                <vs-th sort-key="">Driver</vs-th>

                <vs-th></vs-th>

                <tbody>
                  <vs-tr
                    :data="ticket"
                    :key="indexUsed"
                    v-for="(ticket, indexUsed) in tr.ticket_useds"
                    style="background: #edf1ef"
                  >
                    <vs-td>{{ ticket.uid }}</vs-td>
                    <vs-td>{{ getDate(ticket.updatedAt) }}</vs-td>
                    <vs-td> {{ getTime(ticket.updatedAt) }}</vs-td>
                    <vs-td> {{ ticket.snapshot.product.title }}</vs-td>
                    <vs-td> {{ ticket.snapshot.truck.name }}</vs-td>
                    <vs-td>
                      {{ ticket.snapshot.driver.firstName }}
                      {{ ticket.snapshot.driver.lastName[0] }}</vs-td
                    >

                    <vs-td class="pl-12 ml-2">
                      <vs-button
                        @click.native="deleteTicketFromProject(tr, ticket)"
                        radius
                        color="danger"
                        type="filled"
                        icon-pack="feather"
                        size="small"
                        icon="icon-trash"
                      ></vs-button>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </div>
            </template>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- <vs-pagination
      class="mt-3"
      :total="max"
      v-model="currentPage"
    ></vs-pagination> -->

    <vs-popup
      class="updatePopup"
      title="Update Project"
      :active.sync="popupActivo"
    >
      <h4>Project Information</h4>
      <vs-input label="Name" v-model="projectFields.name" class="mt-5 w-full" />
      <div class="mt-5 flex flex-col textAreaSec">
        <span
          style="
            color: rgba(0, 0, 0, 0.7);
            font-size: 0.85rem;
            padding-left: 5px;
          "
          class=""
          >Description</span
        >
        <textarea
          label="Description ($)"
          v-model="projectFields.description"
          rows="5"
          cols="42"
        />
      </div>
      <div class="mt-8 w-full flex justify-center">
        <vs-button class="mr-6" @click.native="updateProject">
          Update</vs-button
        >
      </div>

      <div class="mt-8">
        <h4 class="mb-2">Add Used Tickets to Project</h4>
        <small class="">Enter the manifest number to search and select.</small>
        <div
          class="mt-8 flex flex-col justify-center"
          style="align-items: center"
        >
          <vue-simple-suggest
            style="min-width: 300px"
            type="number"
            v-model="ticketUsedQuery"
            display-attribute="uid"
            value-attribute="_id"
            :min-length="3"
            :prevent-submit="true"
            :max-suggestions="10"
            :debounce="200"
            :controls="{
              selectionUp: [38, 33],
              selectionDown: [40, 34],
              select: [13, 36],
              hideList: [27, 35],
            }"
            :nullable-select="false"
            :list="getTicketUsedForProject"
            @select="ticketToSent"
            
          >
            <div slot="suggestion-item" slot-scope="{ suggestion }">
              <div class="flex">
                <div>{{ suggestion.uid }}</div>

                <div v-if="suggestion.product">
                  - {{ suggestion.product.title }}
                </div>

                <div v-if="suggestion.driver">
                  - {{ suggestion.driver.firstName
                  }}{{ suggestion.driver.lastName[0] }}
                </div>

                <div v-if="suggestion.truck">
                  - {{ suggestion.truck.licPlate }}
                </div>
                <div v-if="suggestion.manifest">
                  -{{ suggestion.manifest[0].location }}
                </div>
              </div>
            </div>
          </vue-simple-suggest>
          <vs-button class="mt-6" @click.native="updateTicketUsedForProject">
            Add</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DataSidebar from "@/components/DataSidebar.vue";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { $loading, getDate, getTime } from "@/assets/helper";
export default {
  components: {
    DataSidebar,
    VueSimpleSuggest,
  },
  data() {
    return {
      addNewDataSidebar: false,
      projects: [],
      ticketUsedQuery: "",
      ticketUsedId: 0,
      projectFields: {
        id: "",
        name: "",
        description: "",
      },
      ticketUseds: [],
      popupActivo: false,
      itemsPerPage: 10,
      projectTicketUsedList: [],
      addObj: {
        api: "custom",
        apiType: "projects",
        label: "Projects",
        selectClientRole: false,

        fields: [
          {
            label: "Name",
            type: "text",
            field: "name",
            required: true,
          },
          {
            label: "Description",
            type: "textarea",
            field: "description",
            required: true,
          },
        ],
      },
    };
  },
  computed: {
    dataTransformed() {
      if (this.searchedTerm) return this.searchResults;
      return this.projects;
    },
  },
  watch: {
    //   "projectFields"(val, oldVal){
    //   }
  },

  async created() {
    await this.getClientProjects();
  },

  methods: {
    getDate,
    getTime,
    async getClientProjects() {
      let { data } = await this.$get("/projects/account");
      this.projects = data;
      console.log(data);
    },
    async getTicketUsedForProject() {
      let { data } = await this.$get(
        `/accounts/get?where=used&uid_contains=${this.ticketUsedQuery}`
      );
      console.log(data);
      return data;
    },

    async getClientProject(project) {
      this.projectFields = project;

      this.popupActivo = true;
    },
    ticketToSent(suggest) {
      this.ticketUsedId = suggest.id;
    },
    updateTicketUsedForProject() {
      $loading();
      console.log("Update PROJECT Tickets");
      console.log("queryforticketused", this.ticketUsedId);
      this.$update(
        `/projects/account/${this.projectFields.id}/${this.ticketUsedId}`
      )
        .then(({ data }) => {
          this.getClientProjects();
          this.ticketUsedQuery = "";
          this.ticketUsedId = 0;
          this.$vs.notify({
            color: "success",
            title: `Ticket Added`,
            text: `You have sucessfully added the ticket: ${data.uid}.`,
            // accept: () => this.$router.push(`/account/${data.id}`)
          });
        })
        .finally(() => {
          $loading.close();
        });
    },
    addProject(obj) {
      $loading();
      console.log("ADDING PROJECT", obj);
      this.$create("/projects", obj)
        .then(({ data }) => {
          this.getClientProjects();
          this.addNewDataSidebar = false;
          this.$vs.dialog({
            color: "success",
            title: `Account Created`,
            text: `You have sucessfully created the user: ${
              data.name
            }. An email has been dispatched to ${
              data.user.email || "Unknown@email.com"
            } with login details.`,
            // accept: () => this.$router.push(`/account/${data.id}`)
          });
        })
        .finally(() => {
          $loading.close();
        });
    },
    deleteProject(project) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Deletion`,
        text: "You are about to delete this project. Please confirm that this is the action you want to perform.",
        accept: () => this.acceptDelete(project.id),
      });
    },
    async acceptDelete(projectId) {
      this.$delete(`/projects/account/${projectId}`)
        .then(({ data }) => {
          this.getClientProjects();
          this.$vs.notify({
            color: "danger",
            title: "Deleted!",
            text: `The selected project was successfully deleted`,
          });

          // let idx = this.$data[where].findIndex(x => x.id === what.id)
        })
        .catch((err) => {
          console.error("ERROR", err);
        });
    },
    deleteTicketFromProject(project, ticket) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Deletion`,
        text: `You are about to delete ticket ${ticket.uid} from project ${project.name}. Please confirm that this is the action you want to perform.`,
        accept: () => this.acceptTicketDelete(project.id, ticket.id),
      });
    },
    async acceptTicketDelete(projectId, ticketId) {
      this.$delete(`/projects/account/${projectId}/${ticketId}`)
        .then(({ data }) => {
          this.getClientProjects();
          this.$vs.notify({
            color: "danger",
            title: "Deleted!",
            text: `The selected ticket was successfully deleted from the project`,
          });

          // let idx = this.$data[where].findIndex(x => x.id === what.id)
        })
        .catch((err) => {
          console.error("ERROR", err);
        });
    },

    updateProject() {
      if (!this.projectFields) {
        this.$vs.dialog({
          color: "danger",
          title: `Caution`,
          text: `Please fill out all required fields to update the projects`,
          // accept: () => this.$router.push(`/account/${data.id}`)
        });
      }
      $loading();
      console.log(this.projectFields);
      this.$update(
        `/projects/account/${this.projectFields.id}`,
        this.projectFields
      )
        .then(({ data }) => {
          console.log(data);
          this.getClientProjects();
          this.popupActivo = false;

          this.$vs.dialog({
            color: "success",
            title: `Project Updated`,
            text: `You have sucessfully updated the project: ${data.name}`,
            // accept: () => this.$router.push(`/account/${data.id}`)
          });
        })
        .finally(() => {
          $loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.textAreaSec {
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
  }
}
</style>
<style lang="scss">
.projectPage {
  .content-tr-expand {
    padding-left: 30px !important;
  }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
